import { render, staticRenderFns } from "./UserInventionList.vue?vue&type=template&id=7327e541"
import script from "./UserInventionList.vue?vue&type=script&lang=js"
export * from "./UserInventionList.vue?vue&type=script&lang=js"
import style0 from "./UserInventionList.vue?vue&type=style&index=0&id=7327e541&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports